<div *ngIf="planningNeedSolution" class="border border-light bg-light border-5">
	<span
		class="row my-3 theme-main-color fw-bold text-center justify-content-center fs-5"
		>En attente de solution</span
	>
	<span class="row my-3 text-center justify-content-center">
		Il vous reste des affectations à réaliser pour la semaine
		{{ weekNumber }} !
	</span>
	<div class="row my-3 text-center justify-content-center">
		<div class="col-8">
			<div class="d-grid">
				<a
					class="btn theme-main-color-button rounded-pill"
					(click)="buildSolutionPlanning()"
					[routerLink]="'/planning'"
					>Voir plus</a
				>
			</div>
		</div>
	</div>
</div>
<div
	*ngIf="planningNeedValidation"
	class="border border-light border-5 rounded bg-light"
>
	<span
		class="row my-3 theme-main-color fw-bold text-center justify-content-center fs-5"
		>En attente de validation
	</span>
	<span class="row my-3 text-center justify-content-center">
		Vous devez valider le planning de la semaine
		{{ weekNumber }} !
	</span>
	<div class="row my-3 text-center justify-content-center">
		<div class="col-8">
			<div class="d-grid">
				<a
					class="btn theme-main-color-button rounded-pill"
					(click)="validerPlanning()"
					[routerLink]="'/planning'"
					>Valider</a
				>
			</div>
		</div>
	</div>
</div>
<div
	*ngIf="!planningNeedSolution && !planningNeedValidation"
	class="border border-light border-5 rounded bg-light h-100 row d-flex align-items-center justify-content-center"
>
	<div
		class="col-10 theme-main-color fs-5 d-flex justify-content-center text-center"
	>
		Pas de tâche en attente pour la semaine {{ weekNumber }}
	</div>
</div>
